export default __webpack_public_path__ + "static/media/phone-icon.1df737f2.svg";